module.exports = __webpack_public_path__ + "img/nocustomerselected.c81e4648.svg";